import React from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";

import {
  TranslationContext,
  translationService,
} from "../../services/translation/TranslationService";
import Svg from "../svg/Svg";
import { BreadcrumbArrow } from "../svg/svgImageList";
import { useTheme } from "../../services/theme-service/ThemeService";
import { trimStringWithEllipsis } from "../../helpers/StringHelpers";
import useRouteService from "../../services/route-service/RouteService";

interface BreadcrumbItemType {
  textKey: string;
  textContext?: TranslationContext;
  className?: string;
  to?: string;
  isEllipsis?: boolean;
}

export default observer(function BreadcrumbItem(props: BreadcrumbItemType) {
  const { themeClass } = useTheme();
  const { isUserOnProjects, isUserOnJobs } = useRouteService();

  if (!props.textKey) return null;

  const translatedText = props.textContext
    ? translationService.translate(props.textKey, props.textContext)
    : translationService.translate(props.textKey);

  return (
    <>
      <Svg className={themeClass(["collapsible-icon"])} svg={BreadcrumbArrow} />
      {!props.isEllipsis &&
        <Link
          to={props.to || "#"}
          className={props.to ? "active-link-breadcrumb" : "inactive-link-breadcrumb" }
        >
          <span title={translatedText}>
            {isUserOnProjects() || isUserOnJobs() ? trimStringWithEllipsis(translatedText, 30) : translatedText}
          </span>
        </Link>
      }

      {props.isEllipsis &&
        <span> {props.textKey} </span>
      }
    </>
  );
});
